<template>
  <div>
    <div class="h2">
      Coordonnées bancaires
    </div>

    <!-- Nom titulaire du compte -->
    <InputText
      label="Nom titulaire du compte"
      slug="nomTitulaire"
      :model="nomTitulaire"
      :v$="v$"
      @input="$emit('update:nomTitulaire', $event.target.value)"
    />

    <!-- IBAN -->
    <InputText
      v-maska="'XXXX XXXX XXXX XXXX XXXX XXXX XXXX'"
      label="IBAN"
      slug="iban"
      :model="iban"
      :v$="v$"
      @input="$emit('update:iban', $event.target.value)"
    />

    <!-- Nom de la banque -->
    <InputText
      label="Nom de la banque"
      slug="nomBanque"
      :model="nomBanque"
      :v$="v$"
      @input="$emit('update:nomBanque', $event.target.value)"
    />

    <!-- Adresse de la banque -->
    <InputText
      label="Adresse"
      slug="adresseBanque"
      :model="adresseBanque"
      :v$="v$"
      @input="$emit('update:adresseBanque', $event.target.value)"
    />

    <!-- Code postal et ville de la banque -->
    <zip-code-and-city-form
      :code-postal="codePostalBanque"
      code-postal-slug="codePostalBanque"
      code-postal-label="Code postal"
      :ville="villeBanque"
      ville-slug="villeBanque"
      ville-label="Ville"
      :v$="v$"
      @update-code-postal="$emit('update:codePostalBanque', $event)"
      @update-ville="$emit('update:villeBanque', $event)"
    />
  </div>
</template>

<script>

import useVuelidate from '@vuelidate/core'
import {iban, frenchZipCode, required, serverError, maxLength} from "src/modules/shared/validators/validators";
import {computed } from "vue";
import InputText from "src/modules/shared/components/Form/InputText";
import ZipCodeAndCityForm from "src/modules/shared/components/Form/ZipCodeAndCityForm";

export default {
  name: "ContributionInformationForm",
  components: {
    InputText,
    ZipCodeAndCityForm
  },
  props: {
    serverErrors: {
      type: Array,
      required: true
    },
    nomTitulaire: {
      type: String,
      required: true
    },
    iban: {
      type: String,
      required: true
    },
    nomBanque: {
      type: String,
      required: true
    },
    adresseBanque: {
      type: String,
      required: true
    },
    codePostalBanque: {
      type: String,
      required: true
    },
    villeBanque: {
      type: String,
      required: true
    },
  },
  emits: [
    'update:nomTitulaire',
    'update:iban',
    'update:nomBanque',
    'update:adresseBanque',
    'update:codePostalBanque',
    'update:villeBanque'
  ],
  setup (props) {
    const validations = computed(() => ({
      nomTitulaire: {
        required,
        maxLength: maxLength(25),
        serverError: serverError(props, 'nomTitulaire')
      },
      iban: {
        required,
        iban,
        serverError: serverError(props, 'iban')
      },
      nomBanque: {
        required,
        maxLength: maxLength(32),
        serverError: serverError(props, 'nomBanque')
      },
      adresseBanque: {
        required,
        maxLength: maxLength(32),
        serverError: serverError(props, 'adresseBanque')
      },
      codePostalBanque: {
        required,
        frenchZipCode,
        serverError: serverError(props, 'codePostalBanque')
      },
      villeBanque: {
        required,
        serverError: serverError(props, 'villeBanque')
      }
    }))

    const v$ = useVuelidate(validations, props)

    return { v$ }
  },
  watch: {
    serverErrors () {
      this.v$.$reset()
      this.v$.$touch()
    }
  },
}
</script>

<style scoped>

</style>
